import { useMemo } from 'react';
import { Field } from '@common-fe/common-fe';

const useHideFields = (fields: Field[]): Field[] => {
  const filteredFields = useMemo<Field[]>(() => {
    return fields.filter((field) => !field.isAbsent);
  }, [fields]);
  return filteredFields;
};

export default useHideFields;